export class RufusParser {
    parseFile(file) {
        console.log(`Rufus need to be implemented`);
    }

    parseData(data) {
        console.log(`Rufus need to be implemented`);
    }
}